import { Button, Checkbox, Select, InputNumber, Message } from "@arco-design/web-react";
import "./BatchCollection.less";
const Option = Select.Option;
import { useState } from "react";
export interface IBatchCollection {
  handleSelectAll?: () => void;
  handleCancel?: () => void;
  number: number;
  total: number;
  disabeldAll?: boolean;
  disabled?: boolean;
  checkFlag?: boolean;
  showFilterMaterial?: boolean;
  emitFilterMaterial?: (value: number) => void;
  emitFilterDuration?: (obj: any) => void;
}

const BatchCollection: React.FC<IBatchCollection> = (props) => {
  const {
    handleCancel,
    handleSelectAll,
    number,
    total,
    disabeldAll,
    disabled,
    checkFlag,
    showFilterMaterial,
    emitFilterMaterial,
    emitFilterDuration
  } = props;
  const options = [{
    label: "全部",
    value: 0
  }, {
    label: "视频",
    value: 1
  }, {
    label: "图片",
    value: 3
  }];
  const [startTime, setStartTime] = useState<number | null>(null);
  const [endTime, setEndTime] = useState<number | null>(null);
  return (
    <div className="checkbox-wrapper flex--start--center" style={{ height: 30 }}>
      {!disabeldAll ? (
        <Checkbox
          disabled={disabled}
          checked={checkFlag}
          onChange={(e) => {
            if (e) {
              handleSelectAll();
            } else {
              handleCancel();
            }
          }}>
          全选
        </Checkbox>
      ) : (
        <></>
      )}
      <>
        <span className="tip">已选 {number ? "" : 0}</span>
        {number ? <span className="num-tip">{number}</span> : <></>}

        <span>
          {number > 0 ? (
            <Button
              type="text"
              style={{ marginTop: 0, paddingTop: 0, height: 0 }}
              onClick={handleCancel}
              disabled={disabled}>
              取消
            </Button>
          ) : (
            <></>
          )}
        </span>
      </>
      {
        showFilterMaterial && <>
          <Select
              onChange={e => {
                emitFilterMaterial(e);
              }}
              placeholder='请选择'
              style={{ width: 100, marginRight: 20, marginLeft: 20 }}
          >
            {options.map((option, index) => (
              <Option key={option.value} value={option.value}>
                {option.label}
              </Option>
            ))}
          </Select>
          <div className={'flex--center'}>
              <div>时长区间：</div>
              <InputNumber precision={0} suffix='秒' hideControl value={startTime} onBlur={(e) => {
                if (endTime && Number(e.target.value) < endTime) {
                  setStartTime(Number(e.target.value))
                  emitFilterDuration({
                    duration_start: Number(e.target.value),
                    duration_end: endTime
                  })
                }
                if (!endTime) {
                  setStartTime(Number(e.target.value))
                }
                if (endTime && Number(e.target.value) > Number(endTime)) {
                  setStartTime(undefined)
                  Message.error('开始时长必须小于结束时长')
                }
                if (!e.target.value) {
                  setStartTime(undefined)
                  emitFilterDuration({
                    duration_start: 0,
                    duration_end: Number(endTime) || 0
                  })
                }
              }} min={1} max={99999} style={{ width: 100 }} placeholder={'开始时长'} />
              <span style={{ margin: '0 10px' }}>-</span>
              <InputNumber precision={0} suffix='秒' hideControl value={endTime} onBlur={(e) => {
                if (e.target.value > startTime) {
                  setEndTime(Number(e.target.value));
                  emitFilterDuration({
                    duration_start: startTime,
                    duration_end: Number(e.target.value)
                  })
                } else {
                  setEndTime(undefined);
                  Message.error('结束时长必须大于开始时长');
                }
              }} min={1} max={99999} style={{ width: 100 }} placeholder={'结束时长'} />
          </div>
      </>
      }
    </div>
  );
};

export default BatchCollection;
